export enum SHIPPING_STATE {
    WAITING_PAYMENT = 'WAITING_PAYMENT',
    WAITING_ACCEPT = 'WAITING_ACCEPT',
    TO_DELIVERY = 'TO_DELIVERY',
    BEEING_DELIVERED = 'BEEING_DELIVERED',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
}
